// TODO: should be CourseReservation but RHF makes every field `| undefined`
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const calcFormProgress = (formData: any, showGuardian1Address: boolean = true, showGuardian2Address: boolean = true): number => {
  const totalFields = 38;
  let filledInFields = 0;
  for (const field in formData) {
    // current school is optional so doesn't count for progress
    if (field === 'studentSchool') continue;
    // if sole guardian then consider all of guardian 2 filled in
    if (
      [
        'guardian2FirstName',
        'guardian2LastName',
        'guardian2StreetAddress',
        'guardian2City',
        'guardian2Region',
        'guardian2PostalCode',
        'guardian2Country',
        'guardian2Phone',
        'guardian2Email',
      ].includes(field) &&
      formData['guardian1SoleGuardian'] === 'Yes'
    ) {
      filledInFields++;
      continue;
    }
    // if guardian 1 address same as student address consider it filled in
    if (['guardian1StreetAddress', 'guardian1City', 'guardian1Region', 'guardian1PostalCode', 'guardian1Country'].includes(field) && !showGuardian1Address) {
      filledInFields++;
      continue;
    }
    // if guardian 2 address same as student address consider it filled in
    if (['guardian2StreetAddress', 'guardian2City', 'guardian2Region', 'guardian2PostalCode', 'guardian2Country'].includes(field) && !showGuardian2Address) {
      filledInFields++;
      continue;
    }
    // if allergies is 'No' then consider specifics filled in
    if (field === 'studentAllergiesSpecifics' && formData['studentAllergies'] === 'false') {
      filledInFields++;
      continue;
    }
    // if medical is 'No' then consider specifics filled in
    if (field === 'studentMedicalTreatmentSpecifics' && formData['studentMedicalTreatment'] === 'false') {
      filledInFields++;
      continue;
    }
    // if diet is 'No' then consider specifics filled in
    if (field === 'studentDietaryRequirementsSpecifics' && formData['studentDietaryRequirements'] === 'false') {
      filledInFields++;
      continue;
    }
    // if learning is 'No' then consider specifics filled in
    if (field === 'studentLearningDifficultiesSpecifics' && formData['studentLearningDifficulties'] === 'false') {
      filledInFields++;
      continue;
    }
    if (formData[field]) filledInFields++;
  }

  return (filledInFields / totalFields) * 100;
};
